export default __webpack_public_path__ + "static/media/Safety_Thumbnail.6d04221c.png";